module.exports = __webpack_public_path__ + "media/homepage/builder-hero@5x-9d2e38ef.png";